import React from 'react';
import { Mail, Linkedin, MapPin, ArrowUpRight, Download, Twitter, Instagram, Github, Dribbble } from 'lucide-react';

const personalData = {
  name: "Aditya Patil",
  email: "adityapatil9997@gmail.com",
  location: "Newcastle-upon-Tyne, UK",
  linkedin: "www.linkedin.com/in/adityapatil9997/",
  resumeUrl: "/resume.pdf"
};

const socialLinks = [
  {
    name: "LinkedIn",
    url: "www.linkedin.com/in/adityapatil9997/",
    icon: Linkedin
  },
  {
    name: "Medium",
    url: "https://medium.com/@aditya.design",
    icon: ({ size, ...props }) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"/>
      </svg>
    )
  },
  // {
  //   name: "Twitter",
  //   url: "https://twitter.com/adityapatil",
  //   icon: Twitter
  // },
  {
    name: "Instagram",
    url: "https://www.instagram.com/apx97.jpg/",
    icon: Instagram
  },
  // {
  //   name: "Dribbble",
  //   url: "https://dribbble.com/adityapatil",
  //   icon: Dribbble
  // },
  {
    name: "GitHub",
    url: "https://github.com/aditya-9997",
    icon: Github
  }
];

const ContactSection = ({ mode }) => {
  const gradientClass = mode === 'ux' ? 'gradient-text-blue' : 'gradient-text-orange';
  
  return (
    <section id="contact" className="contact-section" data-testid="contact-section">
      <div style={{ maxWidth: '700px', margin: '0 auto' }}>
        <span className="section-label">Get In Touch</span>
        <h2 className="section-title" style={{ marginBottom: '16px' }}>
          Let's Create Something<br />
          <span className={gradientClass}>
            {mode === 'ux' ? 'Impactful' : 'Beautiful'}
          </span> Together
        </h2>
        <p className="subtitle" style={{ margin: '0 auto 28px', textAlign: 'center' }}>
          {mode === 'ux' 
            ? "I'm currently open to UX Research and Design opportunities. Let's discuss how I can contribute to your team."
            : "Interested in collaborating or purchasing prints? I'd love to hear from you."
          }
        </p>

        {/* Resume Download Button */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <a 
            href={personalData.resumeUrl}
            download="Aditya_Patil_UX_Designer.pdf"
            className="resume-button"
            data-testid="download-resume-btn"
          >
            <Download size={18} />
            Download Resume
          </a>
        </div>

        <div className="contact-links">
          <a 
            href={`mailto:${personalData.email}`} 
            className="contact-link"
            data-testid="contact-email"
          >
            <Mail size={18} />
            {personalData.email}
            <ArrowUpRight size={14} />
          </a>
          
          <a 
            href={`https://${personalData.linkedin}`}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
            data-testid="contact-linkedin"
          >
            <Linkedin size={18} />
            LinkedIn
            <ArrowUpRight size={14} />
          </a>
        </div>

        {/* Social Media Links */}
        <div className="social-links" data-testid="social-links">
          {socialLinks.map((social, index) => {
            const IconComponent = social.icon;
            return (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                title={social.name}
                data-testid={`social-${social.name.toLowerCase()}`}
              >
                <IconComponent size={20} />
              </a>
            );
          })}
        </div>

        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          gap: '8px',
          marginTop: '40px',
          color: 'var(--text-tertiary)',
          fontSize: '0.875rem'
        }}>
          <MapPin size={14} />
          <span>{personalData.location}</span>
          <span style={{ margin: '0 6px' }}>•</span>
          <span>Open to relocate</span>
        </div>
      </div>
    </section>
  );
};

const Footer = () => {
  return (
    <footer className="footer" data-testid="footer">
      <p className="footer-text">
        © {new Date().getFullYear()} {personalData.name}. Crafted with passion.
      </p>
    </footer>
  );
};

export { ContactSection, Footer };
